import { TimesheetReviewAlert } from "./TimesheetReviewAlert";

/**
 * Renders on `/timekeeping` and `/submit-timesheet` when the worker has a
 * pending hours adjustment on a verified shift. Reassures that they will
 * still receive shift pay based on their original clock-in time.
 */
export function InShiftAdjustmentTimesheetReviewAlert() {
  return (
    <TimesheetReviewAlert title="Your adjusted time is pending workplace approval.">
      Your request may be reviewed first, and you&apos;ll receive a response within 3 business days.
      Don&apos;t worry - you&apos;ll still receive shift pay based on your original clock in time.
    </TimesheetReviewAlert>
  );
}
